import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dt } from "@/lib/format";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

const ACTION_LABELS = {
  create: "Creazione", update: "Modifica", exchange: "Cambio", verify: "Verifica restituzione",
  deposit: "Movimento cauzione", resolve_anomaly: "Risoluzione anomalia", procure: "Immissione stock",
  stock_move: "Movimento stock",
};
const ENTITY_LABELS = {
  article: "Articolo", kit: "Kit", price_item: "Listino", customer: "Cliente", partner: "Partner",
  cambio_point: "Cambio Point", operator: "Operatore", exchange: "Cambio", return: "Restituzione", anomaly: "Anomalia",
};

export default function AuditLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="Storico / Audit Log" subtitle="Tracciamento delle operazioni importanti" />
      {items.length === 0 ? <EmptyState icon={ScrollText} title="Nessuna operazione registrata" /> : (
        <Card className="divide-y">
          {items.map((l) => (
            <div key={l.id} className="flex items-center justify-between px-4 py-3 text-sm" data-testid={`audit-${l.id}`}>
              <div>
                <p className="font-semibold text-[#0B2447]">{ACTION_LABELS[l.action] || l.action} · {ENTITY_LABELS[l.entity_type] || l.entity_type}</p>
                <p className="text-xs text-slate-400">{l.actor_name || "Sistema"} · {dt(l.created_at)}</p>
              </div>
              {l.new_value && typeof l.new_value !== "object" && <span className="text-xs text-slate-500 max-w-[40%] truncate">{String(l.new_value)}</span>}
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
